import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import React, { useEffect, useState } from 'react';
import { SubSubtitle, SubSubtitleStart, TitleBar } from '.';
import GroupPlanSelector from '../forms/personal/GroupPlanSelector';
import FirstLoading from './FirstLoading';
import MonedaSelector from './MonedaSelector';
import TableSkeleton from './TableSkeleton';
import VigenciaForm from './VigenciaForm';

const maxWidth = 1096;

const SolicitudPlanVigencia = ({
  planSelectorData,
  opcionesDePago,
  vigenciaByAseguradoraList,
  setVigenciaByAseguradoraList,
  moneda,
  monedas,
  setMoneda,
  datosExtra,
  vigenciaSugeridaConfig,
  loading,
  loaded,
  margintLeftPrincipal = 0,
  debouncing,
  onDebounce
}) => {
  const [
    validacionByAseguradoraList,
    setValidacionByAseguradoraList
  ] = useState([]);
  const [mostrarValidaciones, setMostrarValidaciones] = useState(false);
  const screens = useBreakpoint();

  useEffect(() => {
    const existeAlerta = validacionByAseguradoraList.find(
      (item) => item.mostrarAlerta === true
    );
    setMostrarValidaciones(existeAlerta);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vigenciaByAseguradoraList, validacionByAseguradoraList]);
  return (
    <>
      {screens && screens.md === true && (
        <div
          style={{
            textAlign: 'start',
            maxWidth,
            margin: 'auto'
          }}
        >
          {!loaded && (
            <>
              {datosExtra && datosExtra()}
              <TitleBar>
                <SubSubtitleStart
                  level={5}
                  style={{
                    fontWeight: '500'
                  }}
                >
                  Vigencia y forma de pago
                </SubSubtitleStart>
              </TitleBar>
            </>
          )}
          <VigenciaForm
            type="normal"
            hidden={loaded}
            onDebounce={onDebounce}
            vigenciaSugeridaConfig={vigenciaSugeridaConfig}
            loading={loading}
            {...{
              vigenciaByAseguradoraList,
              setVigenciaByAseguradoraList,
              setValidacionByAseguradoraList
            }}
          />
          {!loaded && (
            <>
              {monedas && monedas.length > 0 && (
                <div style={{ marginBottom: 20 }}>
                  <MonedaSelector
                    label={`${
                      monedas?.length === 1 ? 'Moneda' : 'Monedas'
                    } de la cotización`}
                    size="small"
                    value={moneda.codigo}
                    monedas={monedas}
                    onChange={(e) => {
                      const selected = monedas.filter(
                        (item) => item.codigo === e.target.value
                      )[0];
                      setMoneda(selected);
                    }}
                  />
                </div>
              )}
              <TitleBar>
                <SubSubtitleStart
                  level={5}
                  style={{
                    fontWeight: '500'
                  }}
                >
                  Detalle de coberturas
                </SubSubtitleStart>
              </TitleBar>
            </>
          )}
        </div>
      )}
      {screens && screens.md === false && (
        <>
          {!loaded && (
            <>
              {datosExtra && datosExtra()}
              {
                <TitleBar>
                  <SubSubtitle
                    level={5}
                    style={{
                      fontWeight: '500'
                    }}
                  >
                    Vigencia y forma de pago
                  </SubSubtitle>
                </TitleBar>
              }
            </>
          )}

          <VigenciaForm
            hidden={loaded}
            onDebounce={onDebounce}
            center
            vigenciaSugeridaConfig={vigenciaSugeridaConfig}
            {...{
              vigenciaByAseguradoraList,
              setVigenciaByAseguradoraList,
              setValidacionByAseguradoraList
            }}
          />
          {!loaded && (
            <>
              {monedas && monedas.length > 0 && (
                <>
                  <MonedaSelector
                    label={`${
                      monedas?.length === 1 ? 'Moneda' : 'Monedas'
                    } de la cotización`}
                    value={moneda.codigo}
                    monedas={monedas}
                    onChange={(e) => {
                      const selected = monedas.filter(
                        (item) => item.codigo === e.target.value
                      )[0];
                      setMoneda(selected);
                    }}
                  />
                </>
              )}
              <TitleBar>
                <SubSubtitle
                  level={5}
                  style={{
                    fontWeight: '500'
                  }}
                >
                  Detalle de coberturas
                </SubSubtitle>
              </TitleBar>
            </>
          )}
        </>
      )}

      <FirstLoading
        loading={loaded || debouncing}
        loadingContent={
          !loaded && (
            <TableSkeleton
              active={loaded || debouncing}
              style={{
                textAlign: 'start',
                maxWidth
              }}
            />
          )
        }
        loadedOk={!loaded}
        loadingText={loaded && 'Cargando cotización...'}
        failed={
          <span>No se encontraron planes disponibles para esta cotización</span>
        }
        style={{ paddingTop: 20, marginLeft: loaded && margintLeftPrincipal }}
      >
        <div
          style={{
            maxWidth,
            textAlign: 'start',
            margin: 'auto'
          }}
        >
          <div
            style={{
              display: screens && screens.md === false ? '' : 'inline-block',
              textAlign: 'start'
            }}
          >
            <GroupPlanSelector
              {...planSelectorData}
              opcionesDePago={opcionesDePago}
              {...{
                validacionByAseguradoraList,
                setValidacionByAseguradoraList,
                mostrarValidaciones
              }}
              moneda={moneda}
            />
          </div>
        </div>
      </FirstLoading>
    </>
  );
};

export default SolicitudPlanVigencia;
